export default {"src":"/_next/static/media/automatic-data-masking.205909a6.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};